import React from "react";
import { FormattedMessage } from "react-intl";
import { AGENCY_NOTIFICATION_STATUS_LABEL_IDS, } from "../../types/agencyNotification";
import css from "./AgencyNotificationsSection.module.css";
export var AgencyNotificationStatusBadge = function (_a) {
    var status = _a.status;
    return (React.createElement("span", { className: "".concat(css.status, " ").concat(status === "SENT" ? css.statusSent : css.statusUnsent), "data-test-id": "agency-notification-status" },
        React.createElement(FormattedMessage, { id: AGENCY_NOTIFICATION_STATUS_LABEL_IDS[status] })));
};
